import auditClient from '@/services/AuditClient'

export default {
  fetchAll (params) {
    return auditClient.sendRequest(
      'GET',
      'api/v1/logs',
      params
    )
  }
}
